module.exports = " <div class=cov-progress :style=\"{\n    'width': percent+'%',\n    'height': options.height,\n    'background-color': options.canSuccess? options.color : options.failedColor,\n    'opacity': options.show ? 1 : 0\n  }\" _v-06451686=\"\"> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** /home/onlygamescl/onlygames-front/shared/~/vue-html-loader!/home/onlygamescl/onlygames-front/shared/~/vue-loader/lib/template-rewriter.js?id=_v-06451686!/home/onlygamescl/onlygames-front/shared/~/vue-loader/lib/selector.js?type=template&index=0!/home/onlygamescl/onlygames-front/shared/~/vue-progressbar/vue-progressbar.vue
 ** module id = 316
 ** module chunks = 1
 **/